import { create } from "zustand";
export const useAvatarStore = create((set) => ({
  updatedAt: Date.now(),
  refreshAvatar: () => set({ updatedAt: Date.now() }),
}));

export const refreshAvatar = () => {
  return useAvatarStore.setState({
    updatedAt: Date.now(),
  });
};
